<template>
  <v-toolbar dark :class="toolbarColor">
    <v-toolbar-title class="white--text hidden-sm-and-down">{{ title }}</v-toolbar-title>
    <v-toolbar-title class="white--text hidden-md-and-up">Nuevo</v-toolbar-title>
    <v-spacer />
    <v-divider
      class="mx-4"
      inset
      vertical
    />

    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          small
          class="mx-2"
          :name="buttons.save.name"
          :loading="loading"
          :disabled="disabled"
          icon
          v-on="on"
          @click="save"
        >
          <v-icon :name="buttons.save.name">
            {{ buttons.save.icon }}
          </v-icon>
        </v-btn>
      </template>
      <span>{{ buttons.save.name }}</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          small
          class="mx-2"
          :name="buttons.cancel.name"
          icon
          v-on="on"
          @click="cancel"
        >
          <v-icon :name="buttons.cancel.name">
            {{ buttons.cancel.icon }}
          </v-icon>
        </v-btn>
      </template>
      <span>{{ buttons.cancel.name }}</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
      title: {
        type: String,
        required: true,
        default: 'Titulo',
      },
      loading: { default: false },
      readonly: {
        type: Boolean,
        required: false,
        default: false,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
  data: () => ({
    buttons: {
      save: {
        icon: 'mdi-content-save',
        name: 'Guardar',
      },
      cancel: {
        icon: 'mdi-close',
        name: 'Cancelar',
      },
    },
  }),
  computed: {
    ...mapGetters({
      toolbarColor: 'theme/toolbarColor',
    }),
  },
  methods: {
    save(event) {
      this.$emit('save', event.target.name);
    },
    cancel(event) {
      this.$emit('cancel', event.target.name);
    },
  },
};
</script>
